import qz from "qz-tray";
import api from "../api";

let connectPromise = null;
let securityConfigured = false;

async function configureQZSecurity() {
  if (securityConfigured) {
    return;
  }

  qz.security.setSignatureAlgorithm("SHA512");

  qz.security.setCertificatePromise((resolve, reject) => {
    api
      .get("/printer/qz/certificate")
      .then((response) => {
        const certificate = response?.data?.certificate;

        if (!certificate) {
          throw new Error("Certificate QZ tidak tersedia.");
        }

        resolve(certificate);
      })
      .catch((error) => {
        reject(
          new Error(
            error?.response?.data?.detail?.message ||
              error?.response?.data?.message ||
              "Gagal mengambil certificate QZ."
          )
        );
      });
  });

  qz.security.setSignaturePromise((toSign) => {
    return (resolve, reject) => {
      api
        .post("/printer/qz/sign", {
          data: toSign,
        })
        .then((response) => {
          const signature = response?.data?.signature;

          if (!signature) {
            throw new Error("Signature QZ tidak tersedia.");
          }

          resolve(signature);
        })
        .catch((error) => {
          reject(
            new Error(
              error?.response?.data?.detail?.message ||
                error?.response?.data?.message ||
                "Gagal mendapatkan signature QZ."
            )
          );
        });
    };
  });

  securityConfigured = true;
}

export async function connectQZ() {
  await configureQZSecurity();

  if (qz.websocket.isActive()) {
    return true;
  }

  if (!connectPromise) {
    connectPromise = qz.websocket
      .connect()
      .then(() => true)
      .finally(() => {
        connectPromise = null;
      });
  }

  return connectPromise;
}

export function isQZConnected() {
  try {
    return qz.websocket.isActive();
  } catch {
    return false;
  }
}

export async function disconnectQZ() {
  if (!qz.websocket.isActive()) {
    return;
  }

  await qz.websocket.disconnect();
}

export async function findQZPrinters() {
  await connectQZ();
  return qz.printers.find();
}

export async function findQZPrinter(name = "") {
  await connectQZ();

  if (name) {
    return qz.printers.find(name);
  }

  return qz.printers.find();
}

export async function printQZ(printerName, data) {
  if (!printerName) {
    throw new Error("Printer belum dipilih.");
  }

  await connectQZ();

  const config = qz.configs.create(printerName);

  return qz.print(config, data);
}

export { qz };
